const getParentPost = (superPostId, responses, response) => {
  const postIds = response.order.split('.')
    .map(x => parseInt(x))
    .filter(id => id !== superPostId && id !== response.id);
  const parentPostId = postIds[postIds.length - 1];
  return parentPostId && responses.find(x => x.id === parentPostId);
};

const assignParentIds = (superPostId, responses) => {
  return responses.map(r => {
    const parentPost = getParentPost(superPostId, responses, r);
    return {
      ...r,
      parentPostId: parentPost && parentPost.id,
      responses: [],
    };
  });
};

const restructurePostResponses = (superPostId, responses) => {
  const postList = assignParentIds(superPostId, responses);
  postList.forEach(response => {
    if (response.parentPostId) {
      const parentPost = postList.find(x => x.id === response.parentPostId);
      if (parentPost) {
        parentPost.responses.push(response);
      }
    }
  });
  return postList.filter(x => !x.parentPostId);
};

export default restructurePostResponses;
